import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import DataTable from '@repo/ui/data-table'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getCenterTefls } from '../../../../api/centers/center-tefl/get-center-tefls'
import useTranslate from '../../../../lib/hooks/use-translate'
import { CenterTefl } from '../../../../lib/types/models/center-tefl/center-tefl'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'
import { centerTeflColumns } from '../../ol-common/ol-center-program/ol-center-tefl/utils'

type Props = {
  centerId: number
}

const CenterOlLocalStaff = ({ centerId }: Props) => {
  const { t } = useTranslate()

  const { data: centerTefls } = useQuery({
    queryKey: ['center-tefls', centerId],
    queryFn: () => getCenterTefls(centerId)
  })

  return (
    <DataTable<CenterTefl>
      bodyVariant="white"
      paginated={false}
      rowCount={centerTefls?.data.length ?? 0}
      data={centerTefls?.data ?? []}
      manualSorting={false}
      columns={[
        {
          accessorFn: (row) => row.tefl?.lastName,
          accessorKey: 'tefl.lastName',
          header: t('ol.center.tefl.table.lastName'),
          enableSorting: true,
          cell: ({ row }) => {
            const tefl = row.original.tefl

            return tefl ? (
              <Typography variant="secondary-body">
                {row.original.tefl?.lastName.toUpperCase()}
              </Typography>
            ) : (
              <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
                ({t('ol.center.program.activities.tefl.not.assigned')})
              </Typography>
            )
          }
        },
        ...centerTeflColumns(t, true),
        {
          accessorKey: 'staff.phoneNumber',
          header: 'Téléphone',
          enableSorting: true,
          cell: ({ row }) =>
            valueRender(row.original.tefl?.phoneNumber, (n) => formatPhoneNumber(n))
        },
        {
          enableSorting: true,
          accessorKey: 'row.original.tefl.seniorityStartedAt',
          header: '# de séjours',
          cell: ({ row }) =>
            valueRender(row.original.tefl?.seniorityStartedAt, (date) =>
              DateFormatter.getYearsDifference(new Date(), new Date(date)).toString()
            )
        }
      ]}
    />
  )
}

export default CenterOlLocalStaff
